import { Timetable } from './timetable'
import { BookingModalController } from './booking'

export { initQuestAttentionTooltips } from './attention-tooltip'
export { initBookingPaymentReturn } from './booking-return'
export { initBlog } from './index/blog'
export { initFeedbackForm, initCategories } from './show'
export { initReviews } from './show/reviews'
export { initAdultWarning } from './show/adult-warning'
export { initQuestVideos } from './show/video'
export { initQuestSliders } from './show/slider'
export { initCatalog, initQuestsMapPage } from './index/catalog/index'
export { initQuestSchedule } from './schedule'
export { initHelperCardForm } from './helper-card'

export function initTimetable(): void {
  const timetableEl = document.querySelector<HTMLElement>('[data-timetable]')
  if (!timetableEl) {
    return
  }

  new Timetable(timetableEl)
}

export function initBooking(): void {
  const modalEl = document.querySelector<HTMLElement>(
    '[data-modal-name="booking_modal"]'
  )

  if (!modalEl) return

  new BookingModalController()
}
